import { useShallow } from "zustand/react/shallow";
import { motion, AnimatePresence } from "framer-motion";
import useStoreRoom from "store/useStoreRoom";

const DiscardDrawComboIndicator = () => {
    const room = useStoreRoom(useShallow(state => ({ gameState: state.room?.gameState })));

    if(!room?.gameState?.quantityCardsToDraw || room?.gameState?.quantityCardsToDraw === 0) {
        return null;
    }

    return (
        <div className="absolute z-[20] w-10 h-10 rounded-full right-0 top-0 bg-gradient-to-b from-pink-400 to-pink-600 border-2 border-pink-300/40 shadow-[0_2px_8px_rgba(236,72,153,0.5)] flex items-center justify-center overflow-hidden">
            <AnimatePresence mode="wait">
                <motion.span
                    key={room?.gameState?.quantityCardsToDraw}
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: [1.4, 1], opacity: 1 }}
                    exit={{ scale: 0, opacity: 0 }}
                    transition={{ duration: 0.25, ease: "backOut" }}
                    className="text-white font-changa-one text-base drop-shadow-md"
                >
                    +{room?.gameState?.quantityCardsToDraw}
                </motion.span>
            </AnimatePresence>
        </div>
    )
}

export default DiscardDrawComboIndicator;